import { environmentData } from '../environments/env'

// Determine runtime environment
const runEnv = environmentData.run

// MSAL configuration
// Notes:
// - Removed explicit prompt:'login' to allow seamless SSO (was forcing interactive every time)
// - Using localStorage so that tabs share a session (required for proper SSO across same-browser apps)
// - Added navigateToLoginRequestUrl:false to avoid returning to stale cached routes after redirect
// - Added system.loggerOptions placeholder for future diagnostics
export const msalConfig = {
  auth: {
    clientId: environmentData[runEnv].clientId,
    authority: environmentData[runEnv].authority,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage', // Enables SSO across tabs; combined with manual cache clear on logout
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.debug('[MSAL]', message)
        }
      },
      piiLoggingEnabled: false,
    },
  },
}

// Scopes used for initial login (keep minimal for consent UX)
export const loginRequest = {
  scopes: ['User.Read'],
}

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft-ppe.com/v1.0/me',
}
